$(document).ready(function () {
  //Country select modal
  var countrySelectModal = document.getElementById("countrySelectModal");
  if (countrySelectModal) {
    var closeCountryModal = document.getElementById("closeCountryModal");
    // When the user clicks on <span> (x), close the modal

    if (typeof closeCountryModal != "undefined" && closeCountryModal != null) {
      closeCountryModal.onclick = function () {
        countrySelectModal.style.display = "none";
        document.body.classList.remove("modal-open");
      };
    }

    $(".country-selector").click(function () {
      closeCountryModal.style.display = "block";
      countrySelectModal.style.display = "block";
      document.body.classList.add("modal-open");
    });

    $(".country-selector-item").click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      localStorage.setItem("countrySelected", true);
      var href = e.target.href || e.target.getAttribute("data-src");
      if (href) window.location.href = href;
      else {
        countrySelectModal.style.display = "none";
        document.body.classList.remove("modal-open");
      }
    });

    if (!localStorage.getItem("countrySelected")) {
      // 显示弹窗
      closeCountryModal.style.display = "none";
      countrySelectModal.style.display = "block";
      document.body.classList.add("modal-open");
    }
  }
});
